import { Injectable } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './actions';

@Injectable({
	providedIn: 'root',
})
export class LawFirmSearchDispatch {
	@Dispatch()
	Search = (searchValue: string): actions.Search =>
		new actions.Search(searchValue);
}
